import { render, staticRenderFns } from "./normalSelect.vue?vue&type=template&id=8b5228a0&"
import script from "./normalSelect.vue?vue&type=script&lang=js&"
export * from "./normalSelect.vue?vue&type=script&lang=js&"
import style0 from "./normalSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports